import { render, staticRenderFns } from "./GaigachaTransfer.vue?vue&type=template&id=26e42c73&"
import script from "./GaigachaTransfer.vue?vue&type=script&lang=js&"
export * from "./GaigachaTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports